import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function Icon2K24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="2K">
            <path
                d="M11.229 14.013V15.426H6.324V14.31L8.682 12.105C8.91 11.889 9.063 11.706 9.141 11.556C9.219 11.4 9.258 11.244 9.258 11.088C9.258 10.884 9.189 10.725 9.051 10.611C8.913 10.497 8.712 10.44 8.448 10.44C8.214 10.44 7.998 10.494 7.8 10.602C7.608 10.704 7.449 10.854 7.323 11.052L6 10.314C6.246 9.906 6.591 9.585 7.035 9.351C7.479 9.117 8.004 9 8.61 9C9.09 9 9.513 9.078 9.879 9.234C10.251 9.39 10.539 9.615 10.743 9.909C10.953 10.197 11.058 10.533 11.058 10.917C11.058 11.259 10.983 11.583 10.833 11.889C10.689 12.189 10.407 12.531 9.987 12.915L8.799 14.013H11.229Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M14.5017 13.14L13.8357 13.851V15.426H12.0717V9.12598H13.8357V11.745L16.2747 9.12598H18.2367L15.6627 11.916L18.3717 15.426H16.3017L14.5017 13.14Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 5C0 3.89543 0.895431 3 2 3H22C23.1046 3 24 3.89543 24 5V19C24 20.1046 23.1046 21 22 21H2C0.89543 21 0 20.1046 0 19V5ZM2 5H22V19H2L2 5Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
